import FEASTFLEET from "../../thumbnails/FEAST_FLEET.svg"

const ProjectCard = (props)=>{
// console.log("props", props)

    const {name, tech, imageLink, codeLink, demoLink}=props.projData;

    
    
return (

    <div className="m-2 w-80 h-full border-2 border-solid rounded-lg ">

        <div className="img w-full ">
            <img className="h-64 p-2 w-full rounded-t-lg "  src={(imageLink==="")?FEASTFLEET:imageLink} alt="" />
        </div>
        <div className="textDetails p-2 bg-violet-200 text text-[#152757] rounded-b-lg">
            <h4 className="text-3xl text-center">{name}</h4>
            <p className="text-base py-2">{tech}</p>

            <div className="flex justify-around">
                <a href={codeLink} className="flex gap-1 items-center"><img src="https://img.icons8.com/pieces/25/experimental-code-pieces.png" alt="" />Code</a>
                
                <div className="border-l-2 border-[#152757]"></div>
                <a href={demoLink} className="flex gap-1 items-center"> 
                <img  src="https://img.icons8.com/papercut/25/link.png" alt="link"/>
                Demo</a>

            </div>
        </div>

    </div>
)
}

export default ProjectCard;